import React, { useState } from "react";
import { usePersistentState } from "../Common/usePersistentFilters";
import EmployeeCard from "./EmployeeCard";

const EmployeeGrid = ({ employees }) => {
 const [query, setQuery] = usePersistentState("employee_crm_search", "");

 const filtered = employees.filter((e) =>
 e.name.toLowerCase().includes(query.toLowerCase())
 );

 return (
 <div>
 {/* Heading + Search */}
 <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-2 mb-3">
 <h5 style={{ margin: 0 }}>Team Members</h5>

 <input
 type="text"
 className="form-control form-control-sm"
 placeholder="Search employees..."
 style={{
 width: "100%",
 maxWidth: "250px",
 fontSize: "14px"
 }}
 onChange={(e) => setQuery(e.target.value)}
 />
 </div>

 {/* Cards Grid */}
 <div className="row">
 {filtered.length > 0 ? (
 filtered.map((emp, idx) => (
 <div
 key={idx}
 className="col-12 col-sm-6 col-md-6 col-lg-4 mb-3"
 >
 <EmployeeCard emp={emp} />
 </div>
 ))
 ) : (
 <div className="text-muted text-center py-4">
 No employees found.
 </div>
 )}
 </div>
 </div>
 );
};

export default EmployeeGrid;
